import { SQUAD_IMAGE_FORMATS } from './squadImageFormats';

export const SQUAD_ADVISOR_IMAGES = {
  matthias: '/images/squad/advisors/matthias-ruddeck.png',
  stephan: '/images/squad/advisors/stephan-hornung.png',
  christian: '/images/squad/advisors/christian-struck.png',
  discoverCapital: '/images/squad/advisors/discover-capital.png',
} as const;

export const SQUAD_ADVISOR_FOOTER_LOGO = SQUAD_ADVISOR_IMAGES.discoverCapital;

/**
 * Fondsberater photo frame. 16:9 since SQUAD's layout document of 11.09.2026 — it
 * used to be 728 × 320, a shape that was never a standard and that Alex replaced
 * with one he could defend to anyone asking.
 */
export const SQUAD_ADVISOR_PHOTO = {
  heightPx: SQUAD_IMAGE_FORMATS.advisorPhoto.heightPx,
  widthPx: SQUAD_IMAGE_FORMATS.advisorPhoto.widthPx,
  /** CSS aspect-ratio = width / height */
  aspectRatio: SQUAD_IMAGE_FORMATS.advisorPhoto.aspect,
} as const;

export type SquadAdvisorRecord = {
  layout?: 'featured' | 'duo';
  duoGroup?: string;
  name: string;
  company?: string;
  companyLine1?: string;
  companyLine2?: string;
  bio?: string;
  photoUrl?: string;
  logoUrl?: string;
};

export type SquadAdvisorFeaturedBlock = {
  type: 'featured';
  name: string;
  company?: string;
  companyLine1?: string;
  companyLine2?: string;
  bio?: string;
  photoUrl?: string;
  logoUrl?: string;
};

export type SquadAdvisorDuoBlock = {
  type: 'duo';
  company?: string;
  bio?: string;
  people: Array<{ name: string; photoUrl?: string }>;
};

export type SquadAdvisorBlock = SquadAdvisorFeaturedBlock | SquadAdvisorDuoBlock;

/** Single Fondsberater only — Advisor 2/3 (duo) removed from the product. */
export const DEFAULT_ADVISORS: SquadAdvisorRecord[] = [
  {
    layout: 'featured',
    name: 'Matthias Ruddeck',
    companyLine1: 'POINT FIVE',
    companyLine2: 'CAPITAL',
    bio:
      'Matthias Ruddeck verantwortet als Fondsberater die Betreuung des SQUAD Value - A. Er verfügt über langjährige Erfahrung in der Analyse europäischer Aktien- und Anleihenmärkte und begleitet den Fonds seit der Beratungsübernahme.',
    photoUrl: SQUAD_ADVISOR_IMAGES.matthias,
  },
];

/** Keep at most one advisor (featured). Legacy duo rows are dropped. */
export function normalizeSquadAdvisors(advisors: SquadAdvisorRecord[] | null | undefined): SquadAdvisorRecord[] {
  const first = Array.isArray(advisors) ? advisors[0] : undefined;
  if (!first?.name && !first?.photoUrl && !first?.bio) {
    return DEFAULT_ADVISORS.map((a) => ({ ...a }));
  }
  return [
    {
      layout: 'featured',
      name: first.name || '',
      company: first.company,
      companyLine1: first.companyLine1,
      companyLine2: first.companyLine2,
      bio: first.bio,
      photoUrl: first.photoUrl,
      logoUrl: first.logoUrl,
    },
  ];
}

export function buildAdvisorBlocks(advisors: SquadAdvisorRecord[] = []): SquadAdvisorBlock[] {
  const [current] = normalizeSquadAdvisors(advisors);
  if (!current) return [];

  return [
    {
      type: 'featured',
      name: current.name,
      company: current.company,
      companyLine1: current.companyLine1,
      companyLine2: current.companyLine2,
      bio: current.bio,
      photoUrl: current.photoUrl,
      logoUrl: current.logoUrl,
    },
  ];
}
